import {notify} from '@gemcook/notification';
import storage from 'store';

import constants from '@constants';
import paths from '@paths';

import api from '@api';

export const leave = async (
  me: MeStore,
  setLoading: any,
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>,
  setIsFaildModal: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setLoading(true);
  try {
    await api.teams.leave(me.teamId);
    storage.clearAll();
    window.location.assign(paths.landing.main);
  } catch (err) {
    switch (err.response.data.message) {
      case 'card was declined':
        setIsModal(false);
        setIsFaildModal(true);
        break;

      default:
        notify('退会に失敗しました', 'error');
    }
  } finally {
    setLoading(false);
  }
};
